import { ERRORS } from './csvFormatErrorsMessages';

export default {
  WEEK_DAYS: [
    {
      KEY: 'MONDAY',
      VALUE: 'Segunda',
    },
    {
      KEY: 'TUESDAY',
      VALUE: 'Terça',
    },
    {
      KEY: 'WEDNESDAY',
      VALUE: 'Quarta',
    },
    {
      KEY: 'THURSDAY',
      VALUE: 'Quinta',
    },
    {
      KEY: 'FRIDAY',
      VALUE: 'Sexta',
    },
    {
      KEY: 'SATURDAY',
      VALUE: 'Sábado',
    },
    {
      KEY: 'SUNDAY',
      VALUE: 'Domingo',
    },
    {
      KEY: 'HOLIDAYS',
      VALUE: 'Feriado',
    },
  ],
  WEEK_DAYS_HOLIDAYS: [
    {
      KEY: 'MONDAY',
      VALUE: 'Segunda',
    },
    {
      KEY: 'TUESDAY',
      VALUE: 'Terça',
    },
    {
      KEY: 'WEDNESDAY',
      VALUE: 'Quarta',
    },
    {
      KEY: 'THURSDAY',
      VALUE: 'Quinta',
    },
    {
      KEY: 'FRIDAY',
      VALUE: 'Sexta',
    },
    {
      KEY: 'SATURDAY',
      VALUE: 'Sábado',
    },
    {
      KEY: 'SUNDAY',
      VALUE: 'Domingo',
    },
    {
      KEY: 'HOLIDAYS',
      VALUE: 'Feriados',
    },
  ],
  STATUS: {
    INACTIVE: { KEY: 0, VALUE: 'Inativo' },
    ACTIVE: { KEY: 1, VALUE: 'Ativo' },
  },
  OPERATIONS: [
    { KEY: 0, VALUE: 'BUS', NAME: 'Ônibus' },
    { KEY: 1, VALUE: 'METRO', NAME: 'Metrô ' },
    { KEY: 2, VALUE: 'SHIPS', NAME: 'Balsa' },
  ],
  TRIP_SCHEDULE: [
    { KEY: 0, VALUE: 'Oficial' },
    { KEY: 1, VALUE: 'Extra' },
    { KEY: 2, VALUE: 'Vazio' },
    { KEY: 3, VALUE: 'Desativado' },
  ],
};

// Header format of the .csv file
const HEADER_FORMAT = [
  { header: 'point', key: 'Ponto', required: true },
  { header: 'hour', key: 'Hora', required: true },
];

const CSV_MODEL_URL =
  'https://docs.google.com/spreadsheets/d/1dj_xdRcusBSIPYwHdwbB8RxsRCcz-HeqVu48HS96aWk/edit?usp=sharing';

const MAX_FILE_SIZE = 100 * 2 ** 10; // 100 KB ~ 1500 Rows

export { ERRORS, HEADER_FORMAT, MAX_FILE_SIZE, CSV_MODEL_URL };
